import { Fragment, Suspense } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SbSharedRefineMenuShippingFiltersWrapperLazy } from '../SbSharedRefineMenuShippingFilters/SbSharedRefineMenuShippingFiltersWrapperLazy';

export const SbSharedRefineMenuFilterDeliveryOptionsComponent = props => {
    const { isClient, currency, itemSearch, submitOnBlur, refreshOnSumbit } = props;
    const { appliedFilters = [] } = itemSearch;

    return (
        <Fragment>
            {/* Shipping filters */}
            {isClient && (
                <Suspense fallback="">
                    <SbSharedRefineMenuShippingFiltersWrapperLazy
                        currency={currency}
                        submitOnBlur={submitOnBlur}
                        appliedFilterNames={new Set(appliedFilters.map(f => f.name))}
                        refreshOnSumbit={refreshOnSumbit}
                    />
                </Suspense>
            )}
        </Fragment>
    );
};

SbSharedRefineMenuFilterDeliveryOptionsComponent.propTypes = {
    isClient: PropTypes.bool,
    currency: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
    submitOnBlur: PropTypes.bool,
    refreshOnSumbit: PropTypes.bool,
};

export const SbSharedRefineMenuFilterDeliveryOptions = createFragmentContainer(
    SbSharedRefineMenuFilterDeliveryOptionsComponent,
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuFilterDeliveryOptions_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                }
            }
        `,
    }
);
